import React from "react"
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  styled,
  TextField,
} from "@mui/material"

const InputContainer = styled(Box)(() => ({
  width: "30rem",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignContent: "center",
  gap: "1.5rem",
  padding: "5% 0% 0% 7%",
  "@media all and (max-width: 700px)": {
    width: "80%",
  },
}))

const BoxInput = styled(Box)(() => ({
  width: "30rem",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignContent: "center",
  gap: "1.5rem",
  color: "#4B4952",
  fontSize: 18,
  fontFamily: "roboto",
  "@media all and (max-width: 700px)": {
    width: "100%",
  },
}))

const InputButton = styled(Button)(() => ({
  background: "#1C846F",
  "&:hover": {
    background: "#0CABA8",
  },
  borderRadius: "5rem",
  color: "#fff",
}))

export const AdminAccessOrganizationForm = ({
  cuit,
  orgFinishDate,
  hasOrganization,
  hasSearchedOrganization,
  hasOrgBaseAccess,
  validatingOrganization,
  loadingOrgContext,
  enablingOrganizationAccess,
  organizationUsers,
  error,
  successMessage,
  onCuitChange,
  onSearch,
  onOrgFinishDateChange,
  onEnableBaseAccess,

}) => {
  const isSearching = validatingOrganization || loadingOrgContext
  const isBusy = isSearching || enablingOrganizationAccess
  const showSearchError =
    hasSearchedOrganization && !hasOrganization && Boolean(error)


  return (
    <>
      <InputContainer>
        <BoxInput>
          <div style={{ fontWeight: "lighter" }}>
            Ingrese el CUIT de la organización que desea buscar:
          </div>
        </BoxInput>
        <TextField
          fullWidth
          label="CUIT"
          value={cuit}
          onChange={(event) => onCuitChange(event.target.value)}
          placeholder="30XXXXXXXXX"
          disabled={isBusy}
        />
        <InputButton onClick={onSearch} disabled={!cuit || isBusy}>
          {isSearching ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            "Buscar organización"
          )}
        </InputButton>
      </InputContainer>

      {showSearchError ? (
        <Alert severity="error" sx={{ mt: 2, ml: 12, width: '30%' }}>
          No se encontró la organización asociada al CUIT ingresado.
        </Alert>
      ) : null}
    </>
  )
}

export default AdminAccessOrganizationForm
